import SelectedItem from './SelectedItem';

export default SelectedItem;
